import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { h } from 'vue'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import AllMetricsDashIcon from '../icons/AllMetricsDash.vue'
import AllMetricsWoROMAbbrIcon from '../icons/AllMetricsWoROMAbbr.vue'
import AllMetricsWoROMIcon from '../icons/AllMetricsWoROM.vue'
import BaggedVsBulkDashboardIcon from '../icons/BaggedVsBulkDashboard.vue'
import BrandPerformanceByCustomerIcon from '../icons/BrandPerformanceByCustomer.vue'
import BrandRankIcon from '../icons/BrandRank.vue'
import BrandShareIcon from '../icons/BrandShare.vue'
import CategoryInsightsIcon from '../icons/CategoryInsights.vue'
import CategoryItemPerformanceIcon from '../icons/CategoryItemPerformance.vue'
import CombinedMetricsTableIcon from '../icons/CombinedMetricsTable.vue'
import CommodityIcon from '../icons/Commodity.vue'
import CpcDashIcon from '../icons/CpcDash.vue'
import CustomerPerformanceByBrandIcon from '../icons/CustomerPerformanceByBrand.vue'
import CustomerPerformanceBySegmentIcon from '../icons/CustomerPerformanceBySegment.vue'
import CustomTimelineIcon from '../icons/CustomTimeline.vue'
import DashboardIcon from '../icons/Dashboard.vue'
import DashboardDownloadIcon from '../icons/DashboardDownload.vue'
import DashboardExportIcon from '../icons/DashboardExport.vue'
import DeepDiveIcon from '../icons/DeepDive.vue'
import DollarsTableIcon from '../icons/DollarsTable.vue'
import EquivTableIcon from '../icons/EquivTable.vue'
import FiveYearTrendlineIcon from '../icons/FiveYearTrendline.vue'
import GlossaryIcon from '../icons/Glossary.vue'
import HistoricalSynopsisIcon from '../icons/HistoricalSynopsis.vue'
import KpiDashboardIcon from '../icons/KpiDashboard.vue'
import MetricsByWeekIcon from '../icons/MetricsByWeek.vue'
import MovementDownloadIcon from '../icons/MovementDownload.vue'
import organicgirlItemPerformanceIcon from '../icons/organicgirlItemPerformance.vue'
import PriceAnalysisIcon from '../icons/PriceAnalysis.vue'
import PerformanceByVarietyIcon from '../icons/PerformanceByVariety.vue'
import PerformanceTableIcon from '../icons/PerformanceTable.vue'
import PerformanceTimelineIcon from '../icons/PerformanceTimeline.vue'
import PriceBucketsIcon from '../icons/PriceBuckets.vue'
import PriceDistributionIcon from '../icons/PriceDistribution.vue'
import PriceDownloadIcon from '../icons/PriceDownload.vue'
import PricingTableIcon from '../icons/PricingTable.vue'
import PromoByTimeIcon from '../icons/PromoByTime.vue'
import PromotionsIcon from '../icons/Promotions.vue'
import RegionDashboardIcon from '../icons/RegionDashboard.vue'
import RMAVsROMTimelineIcon from '../icons/RMAVsROMTimeline.vue'
import ROMRetailerListIcon from '../icons/ROMRetailerList.vue'
import RetailerVsROMTimelineIcon from '../icons/RetailerVsROMTimeline.vue'
import RevenueGenerationIcon from '../icons/RevenueGeneration.vue'
import SalesTableIcon from '../icons/SalesTable.vue'
import SegmentShareIcon from '../icons/SegmentShare.vue'
import ShareByQuarterDashIcon from '../icons/ShareByQuarterDash.vue'
import SkuRankIcon from '../icons/SkuRank.vue'
import SubCategoryRankIcon from '../icons/SubCategoryRank.vue'
import SugarbeeKpiIcon from '../icons/SugarbeeKpi.vue'
import TimeAllMetricsTableIcon from '../icons/TimeAllMetricsTable.vue'
import TimeCombinedTableIcon from '../icons/TimeCombinedTable.vue'
import TimePerformanceTableIcon from '../icons/TimePerformanceTable.vue'
import TimePriceTableIcon from '../icons/TimePriceTable.vue'
import TimeSalesTableIcon from '../icons/TimeSalesTable.vue'
import TimeVolumeSalesTableIcon from '../icons/TimeVolumeSalesTable.vue'
import TimeVolumeTableIcon from '../icons/TimeVolumeTable.vue'
import TopItemSnapshotIcon from '../icons/TopItemSnapshot.vue'
import TotalProduceTableIcon from '../icons/TotalProduceTable.vue'
import TotalsDashboardIcon from '../icons/TotalsDashboard.vue'
import UnitsTableIcon from '../icons/UnitsTable.vue'
import VelocityDashIcon from '../icons/VelocityDash.vue'
import VolumeDollarsTableIcon from '../icons/VolumeDollarsTable.vue'
import VolumeTableIcon from '../icons/VolumeTable.vue'
import YoyTrendTableIcon from '../icons/YoyTrendTable.vue'

const customIconComponents = {
  allMetricsDash: AllMetricsDashIcon,
  allMetricsWoROMAbbr: AllMetricsWoROMAbbrIcon,
  allMetricsWoROM: AllMetricsWoROMIcon,
  baggedVsBulkDashboard: BaggedVsBulkDashboardIcon,
  brandPerformanceByCustomer: BrandPerformanceByCustomerIcon,
  brandRank: BrandRankIcon,
  brandShare: BrandShareIcon,
  categoryInsights: CategoryInsightsIcon,
  categoryItemPerformance: CategoryItemPerformanceIcon,
  combinedMetricsTable: CombinedMetricsTableIcon,
  commodity: CommodityIcon,
  cpcDash: CpcDashIcon,
  customerPerformanceByBrand: CustomerPerformanceByBrandIcon,
  customerPerformanceBySegment: CustomerPerformanceBySegmentIcon,
  customTimeline: CustomTimelineIcon,
  dashboard: DashboardIcon,
  dashboardDownload: DashboardDownloadIcon,
  dashboardExport: DashboardExportIcon,
  deepDive: DeepDiveIcon,
  dollarsTable: DollarsTableIcon,
  equivTable: EquivTableIcon,
  fiveYearTrendline: FiveYearTrendlineIcon,
  glossary: GlossaryIcon,
  historicalSynopsis: HistoricalSynopsisIcon,
  kpiDashboard: KpiDashboardIcon,
  metricsByWeek: MetricsByWeekIcon,
  movementDownload: MovementDownloadIcon,
  organicgirlItemPerformance: organicgirlItemPerformanceIcon,
  priceAnalysis: PriceAnalysisIcon,
  performanceByVariety: PerformanceByVarietyIcon,
  performanceTable: PerformanceTableIcon,
  performanceTimeline: PerformanceTimelineIcon,
  priceBuckets: PriceBucketsIcon,
  priceDistribution: PriceDistributionIcon,
  priceDownload: PriceDownloadIcon,
  pricingTable: PricingTableIcon,
  promoByTime: PromoByTimeIcon,
  promotions: PromotionsIcon,
  regionDashboard: RegionDashboardIcon,
  RMAVsROMTimeline: RMAVsROMTimelineIcon,
  ROMRetailerList: ROMRetailerListIcon,
  retailerVsROMTimeline: RetailerVsROMTimelineIcon,
  revenueGeneration: RevenueGenerationIcon,
  salesTable: SalesTableIcon,
  segmentShare: SegmentShareIcon,
  shareByQuarterDash: ShareByQuarterDashIcon,
  skuRank: SkuRankIcon,
  subCategoryRank: SubCategoryRankIcon,
  sugarbeeKpi: SugarbeeKpiIcon,
  timeAllMetricsTable: TimeAllMetricsTableIcon,
  timeCombinedTable: TimeCombinedTableIcon,
  timePerformanceTable: TimePerformanceTableIcon,
  timePriceTable: TimePriceTableIcon,
  timeSalesTable: TimeSalesTableIcon,
  timeVolumeSalesTable: TimeVolumeSalesTableIcon,
  timeVolumeTable: TimeVolumeTableIcon,
  topItemSnapshot: TopItemSnapshotIcon,
  totalProduceTable: TotalProduceTableIcon,
  totalsDashboard: TotalsDashboardIcon,
  unitsTable: UnitsTableIcon,
  velocityDash: VelocityDashIcon,
  volumeDollarsTable: VolumeDollarsTableIcon,
  volumeTable: VolumeTableIcon,
  yoyTrendTable: YoyTrendTableIcon,
}

const customIconSet = {
  component: (props) => {
    const iconName = props.icon
    const component = customIconComponents[iconName]
    if (!component) {
      console.warn(`[Vuetify] Custom icon '${iconName}' not found.`)
      return h('div') // Return an empty div or a placeholder icon
    }
    return h(component, props)
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          mainBack: '#edeef0',
          primary: '#032341',
          'primary-darken-1': '#071528',
          'primary-darken-2': '#072044',
          'primary-lighten-1': '#102754',
          secondary: '#007995',
          'secondary-lighten-1': '#00b6cd',
          'secondary-lighten-2': '#8DD2CD',
          'secondary-lighten-3': '#C3E9EA',
          insights: '#fff',
          'chat-hover': '#f5f5f5',
          'chat-selected': '#e3f2fd',
          'message': '#e3f2fd', 
          'assistant': '#fff',
          'tool': 'rgb(235, 235, 235)',
          'table-head': '#eceff1',
          'table-copy': '#fff',
          border: '#cfd8dc',
          navButton: '#000000de',
          accent: '#cfeae0',
          error: '#9F2014',
          warning: '#DF8D2B',
          info: '#59c5c7',
          success: '#498E6F',
          notification: '#007995',
        },
      },
      dark: {
        colors: {
          mainBack: '#121212',
          primary: '#032341',
          'primary-darken-1': '#071528',
          'primary-darken-2': '#072044',
          'primary-lighten-1': '#102754',
          secondary: '#007995',
          'secondary-lighten-1': '#00b6cd',
          'secondary-lighten-2': '#8DD2CD',
          'secondary-lighten-3': '#C3E9EA',
          insights: '#121212',
          'chat-hover': '#292929',
          'chat-selected': '#1e3a4f',
          'message': '#1e3a4f',
          'assistant': '#1e1e1e',
          'tool': '#2a2a2a',
          'table-head': '#303030',
          'table-copy': '#1e1e1e',
          border: '#424242',
          navButton: '#FFFFFFDE',
          accent: '#1f3d34',
          error: '#9F2014',
          warning: '#DF8D2B',
          info: '#59c5c7',
          success: '#498E6F',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi', // Material Design Icons is the default
    sets: {
      custom: customIconSet,
    },
    aliases: {
      allMetricsDash: 'custom:allMetricsDash',
      allMetricsWoROMAbbr: 'custom:allMetricsWoROMAbbr',
      allMetricsWoROM: 'custom:allMetricsWoROM',
      baggedVsBulkDashboard: 'custom:baggedVsBulkDashboard',
      brandPerformanceByCustomer: 'custom:brandPerformanceByCustomer',
      brandRank: 'custom:brandRank',
      brandShare: 'custom:brandShare',
      categoryInsights: 'custom:categoryInsights',
      categoryItemPerformance: 'custom:categoryItemPerformance',
      combinedMetricsTable: 'custom:combinedMetricsTable',
      commodity: 'custom:commodity',
      cpcDash: 'custom:cpcDash',
      customerPerformanceByBrand: 'custom:customerPerformanceByBrand',
      customerPerformanceBySegment: 'custom:customerPerformanceBySegment',
      customTimeline: 'custom:customTimeline',
      dashboard: 'custom:dashboard',
      dashboardDownload: 'custom:dashboardDownload',
      dashboardExport: 'custom:dashboardExport',
      deepDive: 'custom:deepDive',
      dollarsTable: 'custom:dollarsTable',
      equivTable: 'custom:equivTable',
      fiveYearTrendline: 'custom:fiveYearTrendline',
      glossary: 'custom:glossary',
      historicalSynopsis: 'custom:historicalSynopsis',
      kpiDashboard: 'custom:kpiDashboard',
      metricsByWeek: 'custom:metricsByWeek',
      movementDownload: 'custom:movementDownload',
      organicgirlItemPerformance: 'custom:organicgirlItemPerformance',
      performanceByVariety: 'custom:performanceByVariety',
      performanceTable: 'custom:performanceTable',
      performanceTimeline: 'custom:performanceTimeline',
      priceAnalysis: 'custom:priceAnalysis',
      priceBuckets: 'custom:priceBuckets',
      priceDistribution: 'custom:priceDistribution',
      priceDownload: 'custom:priceDownload',
      pricingTable: 'custom:pricingTable',
      promoByTime: 'custom:promoByTime',
      promotions: 'custom:promotions',
      regionDashboard: 'custom:regionDashboard',
      retailerVsROMTimeline: 'custom:retailerVsROMTimeline',
      revenueGeneration: 'custom:revenueGeneration',
      RMAVsROMTimeline: 'custom:RMAVsROMTimeline',
      ROMRetailerList: 'custom:ROMRetailerList',
      salesTable: 'custom:salesTable',
      segmentShare: 'custom:segmentShare',
      shareByQuarterDash: 'custom:shareByQuarterDash',
      skuRank: 'custom:skuRank',
      subCategoryRank: 'custom:subCategoryRank',
      sugarbeeKpi: 'custom:sugarbeeKpi',
      timeAllMetricsTable: 'custom:timeAllMetricsTable',
      timeCombinedTable: 'custom:timeCombinedTable',
      timePerformanceTable: 'custom:timePerformanceTable',
      timePriceTable: 'custom:timePriceTable',
      timeSalesTable: 'custom:timeSalesTable',
      timeVolumeSalesTable: 'custom:timeVolumeSalesTable',
      timeVolumeTable: 'custom:timeVolumeTable',
      topItemSnapshot: 'custom:topItemSnapshot',
      totalProduceTable: 'custom:totalProduceTable',
      totalsDashboard: 'custom:totalsDashboard',
      unitsTable: 'custom:unitsTable',
      velocityDash: 'custom:velocityDash',
      volumeDollarsTable: 'custom:volumeDollarsTable',
      volumeTable: 'custom:volumeTable',
      yoyTrendTable: 'custom:yoyTrendTable',
    },
  },
});